module.exports = __webpack_public_path__ + "img/pirl.748fc297.svg";